import { fetchFactory } from 'isotope-client'
import { YtdStatistics } from '../types'

export const getManuallyClosedContracts = (salesRepId?: string) : Promise<YtdStatistics> => fetchFactory(`/contracts-negotiations/manually-closed-contracts/${salesRepId || 'me'}`, {}, '/api')